module.exports = __webpack_public_path__ + "static/media/DidactGothic-Regular.dda9b9ee.ttf";